<tt-page *ngIf="!!page">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input ttLabel="bsp_keyno" [ttModel]="page.bsp_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="bsp_name" [(ttModel)]="page.bsp_name" ttRequired></tt-input>
        <tt-input ttLabel="reg_by_user" [ttModel]="page.reg_by_user" ttReadonly></tt-input>
        <tt-input ttLabel="reg_datetime" [ttModel]="page.reg_datetime" ttReadonly></tt-input>
        <tt-button-save ttText="bsp_save" (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
